import { Navigate, useLocation } from "react-router-dom";
import DashboardStudent from "./DashboardStudent";
import StudentProgress from "./StudentProgress";
import StudentAttendance from "./StudentAttendance";
import StudentProfile from "./StudentProfile";

export default function ProtectedStudentDashboard({ hifzUser, onLogout }) {
  const location = useLocation();
  const pathname = location.pathname || "";
  const params = new URLSearchParams(location.search);
  const deepLinkToken = params.get("token");

  const isProgress = pathname === "/dashboard-student/progress";
  const isAttendance = pathname === "/dashboard-student/attendance";
  const isProfile = pathname === "/dashboard-student/profile";

  const childProps = { user: hifzUser, onLogout };

  if (hifzUser?.role === "student") {
    if (isProfile) return <StudentProfile {...childProps} />;
    if (isProgress) return <StudentProgress {...childProps} />;
    if (isAttendance) return <StudentAttendance {...childProps} />;
    return <DashboardStudent {...childProps} />;
  }

  if (deepLinkToken) {
    if (isProfile) return <StudentProfile onLogout={onLogout} />;
    if (isProgress) return <StudentProgress onLogout={onLogout} />;
    if (isAttendance) return <StudentAttendance onLogout={onLogout} />;
    return <DashboardStudent onLogout={onLogout} />;
  }

  return <Navigate to="/hifz-login" replace />;
}
